import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import tata3 from "../../../../../assets/images/OUR SERVICES/Tata1.jpeg";
import tata2 from "../../../../../assets/images/OUR SERVICES/Tata2.jpeg";
import tata1 from "../../../../../assets/images/OUR SERVICES/Tata3.jpeg";
import tatalogo from "../../../../../assets/images/OUR SERVICES/tatamachines.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const TataMachine = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Tata Coffee Machine</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={12} md={12} className="text-center">
                                    <img
                                        src={tatalogo}
                                        alt="Tata Logo"
                                        className="img-fluid rounded"
                                        style={{ width: "200PX", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12} className="text-center">
                                    <img
                                        src={tata1}
                                        alt="Office Stationery"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold" style={{ color: "rgb(52, 81, 159)" }}>M12 Coffee Vending Machine</h3>
                                    <p className="text-black"> <strong>Versatile Beverage Selection</strong> – Enjoy 24+ beverage variants, including premium coffee and tea options.</p>
                                    <p className="text-black"> <strong>High Capacity</strong> – Serves 300+ cups per day, making it ideal for high-demand locations.</p>
                                    <p className="text-black"> <strong>Dual Cup Dispensing</strong> – Efficiently serves two cups simultaneously for faster service.</p>
                                    <p className="text-black"> <strong>Built-In Features</strong> – Comes with an in-built steamer, external steam wand, and water storage.</p>
                                    <p className="text-black"> <strong>Easy Maintenance</strong> – Auto-cleaning with descaling liquid, solution, and tablets for hassle-free upkeep.</p>
                                    <p className="text-black"> <strong>Ideal for Various Spaces</strong> – Perfect for large and medium offices, HoReCa, and retail stores.</p>
                                    <p className="text-black"><strong>Beverages:</strong> Cappuccino, Espresso, Latte, Latte Macchiato, Ristretto, Americano, Café Lungo, Black Coffee, Café Crème, Espresso Macchiato, Pot of Coffee, Filter Coffee, Assam Tea, Ginger Tea, Cardamom Tea, Masala Tea, Green Ginger Mint Tea, Green Honey Lemon Tea, Green Tulsi Tea, Green Mango Tea, Lemon Tea.</p>
                                </Col>

                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold" style={{ color: "rgb(52, 81, 159)" }}>E30 Coffee Vending Machine</h3>
                                    <p className="text-black"> <strong>Premium Coffee Experience</strong> – Enjoy 8+ rich and aromatic coffee and tea variants.</p>
                                    <p className="text-black"> <strong>High-Performance Dispensing</strong> – Capable of serving 100+ cups per day, ensuring efficiency in busy spaces.</p>
                                    <p className="text-black"> <strong>Built-In Steamer & Water Storage</strong> – Equipped with an inbuilt steamer and water storage for seamless operations.</p>
                                    <p className="text-black"> <strong>Easy Maintenance</strong> – Auto-cleaning functionality with descaling liquid, solution, and tablets for effortless upkeep.</p>
                                    <p className="text-black"> <strong>Versatile Beverage Selection</strong> – Offers popular coffee options like Cappuccino, Espresso, Latte, and Americano, along with flavorful teas including Cardamom, Masala, and Green Honey Lemon.</p>
                                    <p className="text-black"> <strong>Perfect for Various Locations</strong> – Suitable for offices, retail stores, and hospitality sectors.</p>
                                    <p className="text-black"><strong>Beverages:</strong> Cappuccino, Espresso, Latte, Latte Macchiato, Ristretto, Americano, Hot Water, Hot Milk, Cardamom Tea, Masala Tea, Green Ginger Mint Tea, Green Honey Lemon Tea, Green Tulsi Tea, Green Mango Tea, Lemon Tea.</p>
                                </Col>
                                <Col lg={6} md={12} className="text-center">
                                    <img
                                        src={tata2}
                                        alt="Office Stationery"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>

                                <Col lg={6} md={12} className="text-center">
                                    <img
                                        src={tata3}
                                        alt="Office Stationery"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold" style={{ color: "rgb(52, 81, 159)" }}>Tata Filter Coffee Vending Machine</h3>
                                    <p className="text-black"> <strong>Authentic Filter Coffee Experience</strong> – Dispenses 8+ rich and flavorful coffee and tea variants.</p>
                                    <p className="text-black"> <strong>High-Capacity Serving</strong> – Efficiently serves 300+ cups per day, ideal for high-traffic areas.</p>
                                    <p className="text-black"> <strong>Perfect for Workspaces</strong> – Designed for large and medium offices, ensuring quick and hassle-free beverage access.</p>
                                    <p className="text-black"> <strong>Easy Maintenance</strong> – Auto-cleaning feature with descaling capability for smooth operation.</p>
                                    <p className="text-black"> <strong>Diverse Beverage Options</strong> – Enjoy filter coffee, strong coffee, black coffee, and a variety of teas, including strong tea, light tea, and black tea.</p>
                                    <p className="text-black"> <strong>Additional Offerings</strong> – Relish hot chocolate, badam milk, tomato soup, and hot & sour soup for a complete refreshment solution.</p>
                                </Col>


                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default TataMachine;